module.exports = __webpack_public_path__ + "img/avatarblank.9eb6223.jpg";